import { EBusinessProviders } from '@/components/BusinessTypeSelector/business-providers.enum';
import { Route } from '@/router/route.model';
import { widgetIsActive } from '@/router/validators/utils';

export function needProviderConnected(route: Route) {
  return route.meta.needProviderConnected && !widgetIsActive();
}

export function isOnlineProvider(name: string) {
  return [
    EBusinessProviders.WIX,
    EBusinessProviders.SHOPIFY,
    EBusinessProviders.BIGCOMMERCE,
    EBusinessProviders.WOOCOMMERCE
  ].includes(name as EBusinessProviders);
}

export function isBothProvider(name: string) {
  return [EBusinessProviders.WIX].includes(name as EBusinessProviders);
}
